import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1022KtoDupRefStatus: 'idle',
    startProcess1022KtoDupRefError: undefined as any,
    loadUserParamsProcess1022KtoDupRefStatus: 'idle',
    loadUserParamsProcess1022KtoDupRefError: undefined as any,

    process1022KtoDupRefList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1022KtoDupRef = createAsyncThunk('process1022KtoDupRefSlice/startProcess1022KtoDupRef', async ({ process1022KtoDupRef }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1022KtoDupRef/`,
        prepareData(process1022KtoDupRef),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1022KtoDupRefStatus } = getState().process1022KtoDupRefSlice
        return startProcess1022KtoDupRefStatus !== 'pending'
    }
})

export const loadUserParamsProcess1022KtoDupRef = createAsyncThunk('process1022KtoDupRefSlice/loadUserParamsProcess1022KtoDupRef', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1022KtoDupRef/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1022KtoDupRefStatus } = getState().process1022KtoDupRefSlice
        return loadUserParamsProcess1022KtoDupRefStatus !== 'pending'
    }
})

const Process1022KtoDupRefSlice = createSlice({
    name: 'process1022KtoDupRefSlice',
    initialState,
    reducers: {
        resetstartProcess1022KtoDupRef: (state) => {
            state.job = undefined
            state.startProcess1022KtoDupRefError = undefined
        },
        resetstartProcess1022KtoDupRefError: (state) => {
            state.startProcess1022KtoDupRefError = undefined
        },
        resetloadUserParamsProcess1022KtoDupRef: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1022KtoDupRefError = undefined
        },
        resetloadUserParamsProcess1022KtoDupRefError: (state) => {
            state.loadUserParamsProcess1022KtoDupRefError = undefined
        },
        removeFromProcess1022KtoDupRefListById: (state, action) => {
            state.process1022KtoDupRefList = state.process1022KtoDupRefList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1022KtoDupRefListByIds: (state, action) => {
            state.process1022KtoDupRefList = state.process1022KtoDupRefList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1022KtoDupRefList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1022KtoDupRefStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1022KtoDupRefList = []
            state.startProcess1022KtoDupRefStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1022KtoDupRef.pending, (state) => {
            state.startProcess1022KtoDupRefStatus = 'pending'
            state.startProcess1022KtoDupRefError = undefined
        })
        builder.addCase(startProcess1022KtoDupRef.fulfilled, (state, action) => {
            state.startProcess1022KtoDupRefStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1022KtoDupRef.rejected, (state, action) => {
            state.startProcess1022KtoDupRefStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1022KtoDupRefError = action.error.message
            } else {
                state.startProcess1022KtoDupRefError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1022KtoDupRef.pending, (state) => {
            state.loadUserParamsProcess1022KtoDupRefStatus = 'pending'
            state.loadUserParamsProcess1022KtoDupRefError = undefined
        })
        builder.addCase(loadUserParamsProcess1022KtoDupRef.fulfilled, (state, action) => {
            state.loadUserParamsProcess1022KtoDupRefStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1022KtoDupRef.rejected, (state, action) => {
            state.loadUserParamsProcess1022KtoDupRefStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1022KtoDupRefError = action.error.message
            } else {
                state.loadUserParamsProcess1022KtoDupRefError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1022KtoDupRef,
    resetstartProcess1022KtoDupRefError,
    resetloadUserParamsProcess1022KtoDupRef,
    resetloadUserParamsProcess1022KtoDupRefError,
    removeFromProcess1022KtoDupRefListById,
    removeFromProcess1022KtoDupRefListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1022KtoDupRefSlice.actions
export default Process1022KtoDupRefSlice.reducer
